"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSideCart = void 0;
const useFeatureFlag_1 = require("../../hooks/useFeatureFlag");
const SIDE_CART_FLAG_KEY = 'showSideCart';
const SIMILAR_PRODUCTS_KEY = 'similarProducts';
/**
 * Hook que verifica se o carrinho lateral deve ser exibido
 * Monitora mudanças no localStorage para a chave de similarProducts
 * @returns {boolean} - true se o carrinho lateral deve ser exibido
 */
const useSideCart = () => {
    const [hasSideCart, loading] = (0, useFeatureFlag_1.useFeatureFlag)(SIDE_CART_FLAG_KEY, true);
    return Boolean(hasSideCart) && !loading;
};
exports.useSideCart = useSideCart;
